class ChartsInPopUp {
  constructor() {
    this.init();
  }

  isNotesOpen() {
    return document.body.classList.contains('notes-open');
  }

  executeScripts(wrapper) {
    const scripts = document.body.getElementsByTagName('script');
    Array.prototype.slice.call(scripts).forEach((script) => {
      script.parentNode;
    });


    //console.log(scripts);

    if (scripts.length > 0) {
      for (let j = 0; j < scripts.length; j++) {
        const script = scripts[j];
        const newScript = document.createElement('script');
        newScript.type = 'text/javascript';

        if (script.src) {
          newScript.src = script.src;
        } else {
          newScript.text = script.text;
        }
        if(newScript.src.includes('code.highcharts.com')){
          newScript.src = "";
        }
        document.head.appendChild(newScript);

      }
    }
  }

  executeScriptsInChartWrappers() {
    const chartWrappers = document.getElementsByClassName('lc-chart-wrapper');

    for (let i = 0; i < chartWrappers.length; i++) {
      const wrapper = chartWrappers[i];
      this.executeScripts(wrapper);
    }
  }


  observeMutations() {
    const observer = new MutationObserver((mutationsList) => {
      for (const mutation of mutationsList) {
        if (mutation.attributeName === 'class' && this.isNotesOpen()) {
          this.executeScriptsInChartWrappers();
        }
      }
    });
    observer.observe(document.body, { attributes: true });
  }

  init() {
    if (this.isNotesOpen()) {
      this.executeScriptsInChartWrappers();
    } else {
      this.observeMutations();
    }
  }
}

export default ChartsInPopUp;
